<div class="grid-container margin-top">
  <organization-form [(organization)]="organization" [(parentOrganization)]="parentOrganization" [readOnly]="!canEditOrg" (readOnlyChange)="canEditOrg = $event"></organization-form>
  @if (displayLabel) {
    <div>
      <div class="grid-x margin-top">
        <div class="cell small-12">
          <h4>Organization Departments</h4>
        </div>
      </div>
    </div>
  }
  <organization-departments [(organization)]="organization"></organization-departments>

  <div class="grid-x margin-top">
    <div class="cell small-12">
      <h4>Organization Contacts</h4>
    </div>
  </div>
  <button class="button margin-top" (click)="addContact()">Add Contact</button>
  <organization-contacts [organization]="organization"></organization-contacts>
</div>
